var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-table-filter" }, [
    _c(
      "div",
      { staticClass: "filter-conditions" },
      _vm._l(_vm.clone, function (filter, index) {
        return _c(
          "div",
          { key: index, staticClass: "filter-row" },
          [
            _c("CustomPicker", {
              staticStyle: { width: "30%", "margin-right": "8px" },
              attrs: {
                items: _vm.availableFields,
                idKey: "_id",
                labelKey: "name",
                title: "Field",
                icon: _vm.getFieldIcon(filter.fieldId),
              },
              on: {
                input: function ($event) {
                  return _vm.onFieldChange(filter)
                },
              },
              model: {
                value: filter.fieldId,
                callback: function ($$v) {
                  _vm.$set(filter, "fieldId", $$v)
                },
                expression: "filter.fieldId",
              },
            }),
            _vm._v(" "),
            _c("CustomPicker", {
              staticStyle: { width: "25%", "margin-right": "8px" },
              attrs: {
                items: _vm.getOperators(filter),
                idKey: "value",
                labelKey: "label",
                title: "Operator",
                icon: "filter_list",
                disabled: !filter.fieldId,
              },
              model: {
                value: filter.operator,
                callback: function ($$v) {
                  _vm.$set(filter, "operator", $$v)
                },
                expression: "filter.operator",
              },
            }),
            _vm._v(" "),
            _c(_vm.getValueInputComponent(filter), {
              tag: "component",
              staticStyle: { width: "30%", "margin-right": "8px" },
              attrs: {
                options: _vm.getFieldOptions(filter),
                placeholder: "Value",
                disabled: !filter.operator,
              },
              model: {
                value: filter.value,
                callback: function ($$v) {
                  _vm.$set(filter, "value", $$v)
                },
                expression: "filter.value",
              },
            }),
            _vm._v(" "),
            _c("a-button", {
              attrs: { type: "danger", icon: "delete" },
              on: {
                click: function ($event) {
                  return _vm.removeFilter(index)
                },
              },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-actions" },
      [
        _c(
          "a-button",
          {
            attrs: { type: "dashed", icon: "plus" },
            on: { click: _vm.addFilter },
          },
          [_vm._v(" " + _vm._s(_vm.$t("tables.addCondition")))]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            staticStyle: { float: "right" },
            attrs: { primary: "" },
            on: { click: _vm.applyFilter },
          },
          [_vm._v(" " + _vm._s(_vm.$t("tables.applyFilter")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }